module.exports = __webpack_public_path__ + "static/donate_company_logo02M@2x-dedbebf01a7d8b40da7714aa5ae79ead.png";